import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es'
import TagManagerUtils from '../../utils/TagManagerUtils';
import Input from '../common/input/Input';
import SelectInput from '../common/selectInput/SelectInput';
import i18n from '../../config/I18n';
import { indicadorCurse, simularAction, obtenerDatosPersonaAction, solicitarCreditoAction, mostrarCreditoAction } from '../main/MainAction';
import { validarStepAction, segurosAction } from '../common/Step/StepsAction';
import { agregarformatoPesos, validarNumero, limpiarFormatoPesos, formatNumberUtils } from '../../utils/FormatUtil';
import ModalErrorGenerico from '../common/Modal/ModalErrorGenerico';
import ModalInformativo from '../common/modalInformativo/ModalInformativo';
import Modal from '../common/Modal/Modal';
import loaderAction from '../common/loader/LoaderAction';
import Loader from '../common/loader/Loader';
import Button from '../common/button/Button';
import ListaCheck from '../common/listaCheck/listaCheck'
import ButtonBase from '../common/button/ButtonBase';
import Alert from '../common/alert/alert';
import Tooltip from '../common/tooltip/Tooltip';
import EnfermedadPreexistente from '../common/enfermedadPreexistente/EnfermedadPreexistente';
import { ingresarEnfermedadPreexistenteAction, enfermedadSeleccionadaPorElSocio, obtenerListaDeEnfermedades } from '../common/enfermedadPreexistente/EnfermedadPreexistenteAction';
import icnEmptyState from '../assets/svg/icnEmptyState.svg';
import icnVolverInicio from '../assets/svg/icnVolverInicio.svg';
import icnScrollDownAceptar from '../assets/svg/icnScrollDownAceptar.svg';
import Ejecutivo from '../common/ejecutivo/ejecutivo';
import ModalRechazo from '../rechazo/ModalRechazo';
import { ModalRechazoAction } from '../rechazo/rechazoAction';
import imgModal from '../assets/svg/icnPrecaucionDoc.svg';
import './Step.css';


class Simulador extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.solicitar = this.solicitar.bind(this);
    this.descargar = this.descargar.bind(this)
    this.top = React.createRef();
    this.button = React.createRef();
    this.state = ({
      listaSegurosDisponibles: [],
      rangoPlazo: { min: 6, max: 84 },
      plazo: [],
      solicitud: '',
      solicituFueraRango: null,
      renta: '',
      cuotas: '',
      urlPdf: 'https://componentes-coopeuch.s3.amazonaws.com/seguros-ate-pdw/',
      simulacionInicial: true,
      statusModalInformativo: true,
      verModalSeguro: false
    });
  }



  componentDidMount = async () => {
    const { validaStep, idFlujoSocio, history, obtenerDatosBasicosPersona, token, mostrarCredito, seguros, mostrarLoader, wv } = this.props;

    if (idFlujoSocio === 1) {
      mostrarLoader(true);
      await seguros();
      this.pasrseListaSeguros();
      mostrarCredito();
      this.listaDeEnfermedades();
      obtenerDatosBasicosPersona(token);
      validaStep(1, false);
      mostrarLoader(false);
      const { rangoPlazo } = this.state;
      const newPlazo = [];
      for (let i = 0; i <= rangoPlazo.max; i += 1) {
        if (i >= rangoPlazo.min) {
          newPlazo.push({ "value": i, "label": i })
        }
      }
      this.setState({ plazo: newPlazo });
      // TAG
      TagManagerUtils.globalTag({
        'event': 'vpv-privado',
        'page': '/tef/credito-distancia/simular',
        'ambiente': wv ? 'app':'sitio'
      })
    } else {
      history.push({ pathname: '/Page404' });
    }
  }

  cancelarStep = (e) => {
    e.preventDefault();
    // window.top.location.href = process.env.URL_PORTAL_PRIVADO;
    this.irTop();
    const { rechazar, wv } = this.props;
    // TAGGEO RELIQUIDACION: LE DA CLICK VOLVER AL HOME
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/resultado',
      'eve-cat': 'Click',
      'eve-lab': 'Volver al inicio',
      'ambiente': wv ? 'app':'sitio'
    });
    rechazar();
    TagManagerUtils.globalTag({
      'event': 'vpv-privado',
      'page': '/tef/credito-distancia/encuesta',
      'ambiente': wv ? 'app':'sitio'
    });

  }


  // IR A TOP
  irTop = () => {
    this.top.current.focus();
  }

  // CAMBIO DE DATO EN IMPUT NEWWWW PROYECT

  handleChange = (e) => {
    if (e.target) {
      const valor = limpiarFormatoPesos(e.target.value);
      if (e.target.name === "solicitud" && validarNumero(Number(limpiarFormatoPesos(e.target.value)))) {
        if (Number(valor) < 50000) {
          this.setState({ solicituFueraRango: true });
        } else {
          this.setState({ solicituFueraRango: false });
        }
        this.setState({ solicitud: Number(valor) })
      } else if (e.target.name === "renta" && validarNumero(Number(limpiarFormatoPesos(e.target.value)))) {
        this.setState({ renta: Number(valor) })
      } else if (e.target.type && e.target.type === 'checkbox') {
        this.handleChangeDesgSuperior(e);
      }
    } else if (!e.target && e.value) {
      this.setState({ cuotas: e.value })
    }

  }

  handleChangeDesgSuperior = (e) => {
    const { listaSegurosDisponibles } = this.state;
    let desgravamenSuperiorState = null;
    for (let i = 0; i < listaSegurosDisponibles.length; i += 1) {
      if (listaSegurosDisponibles[i].value === 999) {
        desgravamenSuperiorState = listaSegurosDisponibles[i].isChecked;
        break;
      }
    }
    if (e.target) {
      if (Number(e.target.value) !== 1107) {
        if (Number(e.target.value) === 999 && desgravamenSuperiorState) {
          this.composeListaSeguros(1107);
        } else {
          this.composeListaSeguros(Number(e.target.value));
        }
      } else if (Number(e.target.value) === 1107 && desgravamenSuperiorState) {
        this.composeListaSeguros(1107);
      } else {
        this.handleModalSeguro();
      }
    }
  }

  composeListaSeguros = (e) => {
    const { listaSegurosDisponibles } = this.state;
    // NUEVA LISTA QUE PARTE DE LA PREVIA EXISTENTE
    const newListaSegurosDisponibles = listaSegurosDisponibles;
    // LISTA SELECIONADOS
    const tempLista = []
    // SE RECORRE LA LISTA ORIGINAL Y SE EVALUA PARA CONSTRUIR UNA NUEVA
    for (let i = 0; i < listaSegurosDisponibles.length; i += 1) {
      // CAMBIA ESTADO SEGUN ID Y E
      if (listaSegurosDisponibles[i].value === e) {
        newListaSegurosDisponibles[i].isChecked = !listaSegurosDisponibles[i].isChecked;
      }
      // SI ENTRA 107 Y TENIA 999 ACTIVO LO BLOQUEO
      if (e === 1107 && listaSegurosDisponibles[i].value === 999 && listaSegurosDisponibles[i].isChecked) {
        newListaSegurosDisponibles[i].isChecked = false;
        newListaSegurosDisponibles[0].enable = false;
      }
      // SI VIENE 999 Y 107 ES TRUE
      if (e === 999 && listaSegurosDisponibles[i].value === 1107 && listaSegurosDisponibles[i].isChecked) {
        newListaSegurosDisponibles[0].isChecked = false;
        newListaSegurosDisponibles[0].enable = true;
      }
      // SI VIENE 999 Y 107 ES FALSE
      else if (e === 999 && listaSegurosDisponibles[i].value === 1107 && !listaSegurosDisponibles[0].isChecked) {
        newListaSegurosDisponibles[0].isChecked = true;
        newListaSegurosDisponibles[0].enable = false;
      }
      // SE CONSTRULLE UN NUEVO ARRA CON LOS TRUE
      if (listaSegurosDisponibles[i].isChecked === true) {
        tempLista.push(listaSegurosDisponibles[i].value)
      }
    }
    // SE ACTUALIZA STATE DE LOS SELCIONADOS
    this.setState({ listaSegurosDisponibles: newListaSegurosDisponibles });
  }



  // SE INVOCA SIMULACION
  simular = async () => {
    const { solicitud, renta, cuotas, listaSegurosDisponibles } = this.state;
    const { simular, mostrarLoader, trackId, wv } = this.props;
    const newSeguros = [];
    for (let i = 0; i < listaSegurosDisponibles.length; i += 1) {
      if (listaSegurosDisponibles[i].isChecked) {
        newSeguros.push(listaSegurosDisponibles[i].value)
      }
    }
    mostrarLoader(true);
    await simular(solicitud, renta, cuotas, newSeguros, trackId);
    this.setState({ simulacionInicial: false });
    this.irTop();
    mostrarLoader(false);
    // TAG SI EL SOCIO SIMULA
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/simular',
      'eve-cat': 'Click',
      'eve-lab': 'Simular y ver',
      'ambiente': wv ? 'app':'sitio'
    });

    // TAG SI TIENE SIMULACION 
    const { simulacion, simulacionEstado } = this.props;
    if (simulacionEstado) {
      TagManagerUtils.globalTag({
        'event': 'vpv-privado',
        'page': '/tef/credito-distancia/resultado',
        'monto': simulacion.resultadoSimulacion.montoLiquido,
        'plazo': simulacion.resultadoSimulacion.plazo,
        'valoracion': simulacion.resultadoSimulacion.detalleCredito.tasa,
        'ambiente': wv ? 'app':'sitio'
      });
    }
  }

  // SE OBTIENE LISTA DE ENFERMEDADES

  listaDeEnfermedades = async () => {
    const { obtenerListaDeEnfermedadesPreExistentes } = this.props;
    await obtenerListaDeEnfermedadesPreExistentes();
  }

  // SE ENVIA LA SOLICITUD

  solicitar = async () => {

    const { listaEnfermedadSeleccionada, solicitarCredito, trackId, mostrarLoader } = this.props;
    const newListaEnfermedadSeleccionada = [];
    const stringEnfermedadSeleccionada = []
    for (let i = 0; i < listaEnfermedadSeleccionada.length; i += 1) {
      newListaEnfermedadSeleccionada.push(listaEnfermedadSeleccionada[i].value);
      stringEnfermedadSeleccionada.push(listaEnfermedadSeleccionada[i].label);
    }
    mostrarLoader(true);
    await solicitarCredito(newListaEnfermedadSeleccionada, trackId)

    const { history, validaStep, solicitar, simulacion, wv } = this.props;

    // TAGG
    const { solicitud, cuotas, renta } = this.state;

    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/resultado',
      'eve-cat': 'Click',
      'eve-lab': 'Solicitar oferta',
      'monto': simulacion.resultadoSimulacion.montoLiquido,
      'plazo': cuotas,
      'valoracion': simulacion.resultadoSimulacion.detalleCredito.tasa,
      'preexistencias': stringEnfermedadSeleccionada.join(' - '),
      'ambiente': wv ? 'app':'sitio'
    });


    const lista = simulacion.resultadoSimulacion.segurosContratados.listaSeguros;
    const segurosSelecionados = [];
    for (let i = 0; i < lista.length; i += 1) {
      segurosSelecionados.push(lista[i].descripcion)
    }

    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/simular',
      'eve-cat': 'Click',
      'eve-lab': 'Simular y ver',
      'monto_simulado': solicitud,
      'plazo': cuotas,
      'monto': renta,
      'Seguros': segurosSelecionados.join(' - '),
      'ambiente': wv ? 'app':'sitio'
    })



    if (solicitar) {
      history.push({ pathname: '/Documentos' });
      validaStep(2, false);
    }

  }

  descargar = (descargar) => {
    const { urlPdf } = this.state;
    window.open(`${urlPdf}${descargar}`, 'Download');
  }

  irbutton = () => {
    this.button.current.focus();
    // TAGGEO RELIQUIDACION: LE DA CLICK AL ANCLA DE ACEPTAR OFERTA
  }

  // MODAL DE DERIVACION
  setModalAbandono = () => {
    const { statusModalInformativo } = this.state;
    const { wv } = this.props;
    if (statusModalInformativo) {
      TagManagerUtils.globalTag({
        'event': 'eve',
        'eve-acc': '/tef/credito-distancia',
        'eve-cat': 'Click',
        'eve-lab': 'Modal Entendido',
        'ambiente': wv ? 'app':'sitio'
      })
    }
    this.setState({ statusModalInformativo: !statusModalInformativo });
    this.irTop()
  }

  // METODO QUE INGRESA A LA LISTA LOS DATOS 

  pasrseListaSeguros = () => {
    const { listaSeguros, listaSegurosSelecion, wv } = this.props;
    const nelist = [];
    for (let i = 0; i < listaSeguros.length; i += 1) {
      if (listaSegurosSelecion.includes(Number(listaSeguros[i].value))) {
        listaSeguros[i].isChecked = true;
      } else if (listaSeguros[i].value === 1107) {
        listaSeguros[i].isChecked = true;
      } else {
        listaSeguros[i].isChecked = false
      }
      if (listaSeguros[i].value === 1107) { listaSeguros[i].tooltip = i18n.t('tooltip.desgravamen') };
      if (listaSeguros[i].value === 201) { listaSeguros[i].tooltip = i18n.t('tooltip.cesantia') };
      if (listaSeguros[i].value === 1104) { listaSeguros[i].tooltip = i18n.t('tooltip.hospitalizacion') };
      if (listaSeguros[i].value === 1102) { listaSeguros[i].tooltip = i18n.t('tooltip.InvalidezPermanenteDefinitiva') };
      listaSeguros[i].tooltipTag = {
        "event": "eve",
        "eve-acc": "/tef/credito-distancia/simular",
        "eve-cat": "Click tooltip",
        "eve-lab": listaSeguros[i].name,
        'ambiente': wv ? 'app':'sitio'
      };
      nelist.push(listaSeguros[i]);
    }
    if (listaSegurosSelecion.includes(999)) {
      nelist[0].enable = true;
    }
    this.setState({ listaSegurosDisponibles: nelist });
  }

  handleModalSeguro = () => {
    const { verModalSeguro } = this.state;
    this.setState({ verModalSeguro: !verModalSeguro });
    this.irTop();
  }

  render() {
    const {
      plazo,
      solicitud,
      renta,
      cuotas,
      listaSegurosDisponibles,
      solicituFueraRango,
      simulacionInicial,
      statusModalInformativo,
      verModalSeguro
    } = this.state;

    const {
      showLoader,
      modalErrorGenerico,
      simulacionEstado,
      simulacion,
      simulacionCodeError,
      listaFormatoLabel,
      enEjecucionAPIEnfermedadesPreExistentes,
      ingresarEnfermedad,
      listaEnfermedadSeleccionada,
      motivosRechazoDisponibles,
      wv
    } = this.props;

    const listaSeguros = simulacion != null ? (simulacion.resultadoSimulacion.segurosContratados.listaSeguros.map((item) => (
      <div key={item.descripcion} className="col-12 col-sm-7 col-md-6">
        <div className="row">
          <div className="lista-seguros">
            <div className="col-8 pad10">
              <strong>{item.descripcion}</strong>
            </div>
            <div className="col-4 txtAlignR">
              {agregarformatoPesos(item.monto)}
            </div>
          </div>
        </div>
      </div>
    ))) : null

    return (

      <div className="container-fluid stepContainer simulacion">
        <ModalRechazo idEtapa={2} />
        <div className="top">
          <Input type="text" name="top" reference={this.top} />
        </div>
        <ModalErrorGenerico visible={modalErrorGenerico} wv={wv} />
        <ModalInformativo
          visible={statusModalInformativo}
          ocultar={this.setModalAbandono}
        />
        <Modal
          isOpen={verModalSeguro}
          titulo={i18n.t('seguros.tituloModal')}
          contenido={i18n.t('seguros.infoModal')}
          contenido2={i18n.t('seguros.infoModal2')}
          contenido3={i18n.t('seguros.infoModal3')}
          funcion={this.handleModalSeguro}
          imgModal={imgModal}
          textBtnModal={i18n.t('seguros.botonModal')}
          css='Modalcenter'
        />
        <div className="row">
          <div className={simulacion === null ? "col-sm-10 col-md-3 col-lg-3 offset-sm-1 simulador movile-on" : "col-sm-10 col-md-3 col-lg-3 offset-sm-1 simulador movile-off"}>
            <div className="card">
              <div className="col-12">
                <div className="card-header row">
                  <div className="col-12 txtAlignL pad5">
                    <h3 className="txtBold">
                      {i18n.t('simulacion.cardTile_simulacion')}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="card-body row">
                <div className="col-12 mbottom20">
                  <div className="row">
                    <div className="col-8 pad5">
                      <Input
                        type="text"
                        nombreInput="solicitud"
                        htmlForLabel={i18n.t('simulacion.simu_label_a')}
                        placeHolder={agregarformatoPesos(2000000)}
                        valor={solicitud !== '' && solicitud !== 0 ? agregarformatoPesos(solicitud) : ''}
                        htmlForInfo={i18n.t('simulacion.simu_nota_a')}
                        validarAlert={solicituFueraRango}
                        htmlForAlert={i18n.t('simulacion.labelAlertNoa_a')}
                        funcionOnChange={(e) => { this.handleChange(e) }}
                      // ref={input => input && input.focus()}
                      // reference={this.emailNuevo}
                      />
                    </div>
                    <div className="col-4 pad5">
                      <SelectInput
                        label={i18n.t('simulacion.simu_label_b')}
                        htmlForInfo={i18n.t('simulacion.simu_nota_b')}
                        valor={cuotas ? { "value": cuotas, "label": cuotas } : { "value": 0, "label": 0 }}
                        funcionOnChange={(e) => { this.handleChange(e) }}
                        listaObjetos={plazo}
                      />
                    </div>
                  </div>
                </div>
                {simulacionEstado === false && simulacionCodeError === 32 && (
                  <Alert
                    mensajesEnrriqusidos={[
                      {
                        mensaje: cuotas === 84 ? i18n.t('simulacion.simu_error_b') : i18n.t('simulacion.simu_error_a'),
                        tipo: 'strong'
                      },
                      {
                        mensaje: i18n.t('simulacion.simu_error_c'),
                        tipo: 'normal'
                      }
                    ]}
                    tipo="alert-danger"
                    icons="iconAlertDanger"
                  />
                )}
                <div className="col-12 pad5">
                  <Input
                    type="text"
                    nombreInput="renta"
                    placeHolder={agregarformatoPesos(600000)}
                    htmlForLabel={i18n.t('simulacion.simu_label_c')}
                    valor={renta !== '' && renta !== 0 ? agregarformatoPesos(renta) : ''}
                    // htmlForAlert="mensaje"
                    // htmlForInfo={i18n.t('simulacion.simu_nota_a')}
                    // validarAlert
                    funcionOnChange={(e) => { this.handleChange(e) }}
                    // ref={input => input && input.focus()}
                    // reference={this.emailNuevo}
                    tooltip={i18n.t('tooltip.rentaBruta')}
                    tooltipTag={{
                      'event': 'eve',
                      'eve-acc': '/tef/credito-distancia/simular',
                      'eve-cat': 'Click tooltip',
                      'eve-lab': 'Renta bruta'
                    }}
                  />
                </div>
              </div>
              <hr />
              <div className="card-body row ptop0">
                <div className="col-12 pad5 ptop15 mtop10 mbottom10">
                  <p><strong>{i18n.t('simulacion.seleciona')}</strong></p>
                  <ListaCheck alineacion="vertical" checkboxFunction={(e) => { this.handleChange(e) }} enable checkboxList={listaSegurosDisponibles} />
                  <small>
                    {i18n.t('simulacion.condiciones')}
                    <ButtonBase css="botoonSeguros" etiqueta={i18n.t('simulacion.generales')} callClick={(e) => { this.descargar("condiciones_generales.pdf", e) }} />
                    {i18n.t('simulacion.y')}
                    <ButtonBase css="botoonSeguros" etiqueta={i18n.t('simulacion.particulares')} callClick={(e) => { this.descargar("condiciones_particulares.pdf", e) }} />
                    {i18n.t('simulacion.deLosSeguros')}
                  </small>
                </div>
                <div className="col-12 pad5">
                  <ButtonBase
                    css="botonBaseFlujo Azulbg"
                    etiqueta={simulacionInicial ? i18n.t('simulacion.simular_ver') : i18n.t('simulacion.botton_simular')}
                    callClick={this.simular}
                    enabled={!solicituFueraRango && solicitud !== '' && renta !== '' && cuotas !== '' && solicitud !== 0 && renta !== 0 && cuotas !== 0 ? !false : false}
                  />
                </div>
              </div>
            </div>
            <Ejecutivo
              mensajesEnrriqusidos={[
                {
                  mensaje: i18n.t('ejecutivos.simulacion_a'),
                  tipo: 'normal'
                },
                {
                  mensaje: i18n.t('ejecutivos.simulacion_b'),
                  tipo: 'strong'
                },
                {
                  mensaje: i18n.t('ejecutivos.simulacion_c'),
                  tipo: 'normal'
                }
              ]}
              tipo="top"
            />
          </div>

          <div className="col-sm-12 col-md-7 col-lg-7">
            {simulacionEstado === null && (
              <div className="card fix-card">
                <div className="col-12">
                  <div className="row">
                    <div className="col-4" />
                    <div className="col-4 card-touch" />
                    <div className="col-4" />
                  </div>
                  <div className="card-header row">
                    <div className="col-12 txtAlignL pad5">
                      <h3 className="txtBold">{i18n.t('simulacion.cardTile_resultado')}</h3>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={simulacionEstado === null ? "card movile-off" : "card movile-on"}>
              <div className="col-12 ">
                <span className="desck-off">
                  <div className="row">
                    <div className="col-4" />
                    <div className="col-4 card-touch" />
                    <div className="col-4" />
                  </div>
                </span>

                <div className="card-header row">
                  <div className="col-12 txtAlignL pad5">
                    <h3 className="txtBold">{i18n.t('simulacion.cardTile_resultado')}</h3>
                    {simulacionEstado && (
                      <a className="link" onClick={() => { this.irbutton() }} href="#aceptar">
                        <img src={icnScrollDownAceptar} className="solicitarOferta" alt="svg" />
                        {i18n.t('simulacion.solicitarOferta')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
              {simulacion === simulacionEstado && (
                <>
                  <div className="card-body row mbottom30">
                    <div className="col-sm-6 offset-sm-3 txtAlignC">
                      <img src={icnEmptyState} className="iconSimulacion" alt="svg" />
                      <p>
                        <strong>
                          {i18n.t('simulacion.nota_sin_simulacion_a')}
                        </strong>
                      </p>
                    </div>
                    <div className="col-sm-4 offset-sm-4 txtAlignC">
                      <p>{i18n.t('simulacion.nota_sin_simulacion_b')}</p>
                    </div>
                  </div>
                </>
              )}
              {simulacionEstado !== null && (
                <>
                  <div className="container-fluid">
                    <div className="row resumenHighlight">
                      <div className="col-12 ptop10 pbottom10">
                        <div className="row">
                          <div className="col-12 col-sm-4 col-md-4">
                            <div className="row">
                              <div className="col-12">
                                {simulacionEstado ? i18n.t('simulacion.montoBruto') : (
                                  <div className="row">
                                    <div className="col-6">
                                      <small className="loaderBack mbottom10" />
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-12">
                                <h2>
                                  {simulacionEstado ? (
                                    <>
                                      <small>$</small>
                                      {formatNumberUtils(simulacion.resultadoSimulacion.montoLiquido)}
                                    </>
                                  ) :
                                    (<small className="loaderBack" />)
                                  }
                                </h2>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4">
                            <div className="row">
                              <div className="col-12">
                                {simulacionEstado ? i18n.t('simulacion.plazo') : (
                                  <div className="row">
                                    <div className="col-6">
                                      <small className="loaderBack mbottom10" />
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-12">
                                <h2>
                                  {simulacionEstado ? (
                                    <>
                                      {formatNumberUtils(simulacion.resultadoSimulacion.plazo)}
                                      <small>
                                        {` ${i18n.t('simulacion.meses')}`}
                                      </small>
                                    </>
                                  ) :
                                    (<small className="loaderBack" />)
                                  }
                                </h2>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4">
                            <div className="row">
                              <div className="col-12">
                                {simulacionEstado ? i18n.t('simulacion.valorCuota') : (
                                  <div className="row">
                                    <div className="col-6">
                                      <small className="loaderBack mbottom10" />
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-12">
                                <h2>
                                  {simulacionEstado ? (
                                    <>
                                      <small>$</small>
                                      {formatNumberUtils(simulacion.resultadoSimulacion.valorCuota)}
                                    </>
                                  ) :
                                    (<small className="loaderBack" />)
                                  }
                                </h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pad30 Grisbg">
                    <div className="row ">
                      <div className="col-12 col-sm-12 col-md-12">
                        <h3>
                          {simulacionEstado ? i18n.t('simulacion.detalleCredito') : (<small className="loaderBack mbottom10" />)}
                        </h3>
                      </div>
                    </div>
                    <div className="row pbottom20 detalleCredito">
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-6">
                            <div className="Blancobg shawdow ">
                              <div className="row pad10 ptop10 pbottom10">
                                {simulacionEstado ? (
                                  <>
                                    <div className="col-6 time-leter-space">{i18n.t('simulacion.primerVencimiento')}</div>
                                    <div className="col-6 time-leter-space GrisTX txtAlignR txtBold">
                                      {moment(simulacion.resultadoSimulacion.detalleCredito.fechaPrimerVencimiento, "YYYYMMDD").format('DD [de] MMMM YYYY')}
                                    </div>
                                  </>
                                )
                                  : (
                                    <>
                                      <div className="col-5"><small className="loaderBack" /></div>
                                      <div className="col-2" />
                                      <div className="col-5"><small className="loaderBack" /></div>
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            <hr />
                            <div className="Blancobg shawdow ">
                              <div className="row pad10 ptop10 pbottom10">
                                {simulacionEstado ? (
                                  <>
                                    <div className="col-8">
                                      {i18n.t('simulacion.tasaMensual')}
                                      <Tooltip
                                        message={i18n.t('tooltip.tasaInteres')}
                                        tag={
                                          {
                                            'event': 'eve',
                                            'eve-acc': '/tef/credito-distancia/resultado',
                                            'eve-cat': 'Click tooltip',
                                            'eve-lab': i18n.t('simulacion.tasaMensual'),
                                            'ambiente': wv ? 'app':'sitio'
                                          }
                                        }
                                      />
                                    </div>
                                    <div className="col-4 GrisTX txtAlignR txtBold">
                                      {`${simulacion.resultadoSimulacion.detalleCredito.tasa} %`}
                                    </div>
                                  </>
                                )
                                  : (
                                    <>
                                      <div className="col-5"><small className="loaderBack" /></div>
                                      <div className="col-2" />
                                      <div className="col-5"><small className="loaderBack" /></div>
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            <hr />
                          </div>
                          <div className="col-12 col-sm-6 col-md-6">
                            <div className="Blancobg shawdow ">
                              <div className="row pad10 ptop10 pbottom10">
                                {simulacionEstado ? (
                                  <>
                                    <div className="col-8">
                                      {i18n.t('simulacion.costoTotal')}
                                      <Tooltip
                                        message={i18n.t('tooltip.costoTotalCredito')}
                                        tag={
                                          {
                                            'event': 'eve',
                                            'eve-acc': '/tef/credito-distancia/resultado',
                                            'eve-cat': 'Click tooltip',
                                            'eve-lab': i18n.t('simulacion.costoTotal'),
                                            'ambiente': wv ? 'app':'sitio'
                                          }
                                        }
                                      />
                                    </div>
                                    <div className="col-4 AzulTx txtAlignR txtBold">
                                      {agregarformatoPesos(simulacion.resultadoSimulacion.detalleCredito.costoTotalCredito)}
                                    </div>
                                  </>
                                )
                                  : (
                                    <>
                                      <div className="col-5"><small className="loaderBack" /></div>
                                      <div className="col-2" />
                                      <div className="col-5"><small className="loaderBack" /></div>
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            <hr />
                            <div className="Blancobg shawdow ">
                              <div className="row pad10 ptop10 pbottom10">
                                {simulacionEstado ? (
                                  <>
                                    <div className="col-8">
                                      {i18n.t('simulacion.cargaEquibalente')}
                                      <Tooltip
                                        message={i18n.t('tooltip.CAE')}
                                        tag={
                                          {
                                            'event': 'eve',
                                            'eve-acc': '/tef/credito-distancia/resultado',
                                            'eve-cat': 'Click tooltip',
                                            'eve-lab': i18n.t('simulacion.cargaEquibalente'),
                                            'ambiente': wv ? 'app':'sitio'
                                          }
                                        }
                                      />
                                    </div>
                                    <div className="col-4 GrisTX txtAlignR txtBold">
                                      {`${simulacion.resultadoSimulacion.detalleCredito.cae} %`}
                                    </div>
                                  </>
                                )
                                  : (
                                    <>
                                      <div className="col-5"><small className="loaderBack" /></div>
                                      <div className="col-2" />
                                      <div className="col-5"><small className="loaderBack" /></div>
                                    </>
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="container-fluid pad30">
                    <div className="row">
                      <div className="col-12">
                        <h3>
                          {simulacionEstado ? `${i18n.t('simulacion.segurosContratados')} ${agregarformatoPesos(simulacion.resultadoSimulacion.segurosContratados.total)}` : (<small className="loaderBack" />)}
                        </h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="row  pbottom20">
                          {simulacionEstado ? listaSeguros : (<small className="loaderBack" />)}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {simulacionEstado !== null && simulacionEstado !== false && (
              <>
                <div className="card mbottom20">
                  <div className="col-12">
                    <div className="card-header row">
                      <div className="col-12 txtAlignL pad5">
                        <h3 className=" txtBold">{i18n.t('simulacion.cardTile_declaracion')}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="card-body row">
                    <div className="col-12">
                      <p>
                        {i18n.t('simulacion.notaPrexistencia')}
                        <strong>{i18n.t('simulacion.notaPrexistenciaBold')}</strong>
                      </p>
                      <EnfermedadPreexistente
                        lista={listaFormatoLabel.length >= 1 ? listaFormatoLabel : null}
                        stadoApi={enEjecucionAPIEnfermedadesPreExistentes}
                        onChange={ingresarEnfermedad}
                        estadoActual={listaEnfermedadSeleccionada}
                        max={5}
                      />
                    </div>
                  </div>
                </div>
                <Alert
                  mensaje={i18n.t('simulacion.alertPrexistencia')}
                  tipo="alert-info"
                  icons="icnAlertInfo"
                />
              </>
            )}
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                  <div className="top">
                    <Input type="text" name="button" reference={this.button} />
                  </div>
                  <div className={simulacionEstado === null ? "col-sm-4 movile-off" : "col-sm-4 movile-on"}>
                    <Button callClick={this.solicitar} buttonName={i18n.t('ui.solicitarOferta')} enabled={simulacionEstado !== null && listaEnfermedadSeleccionada !== null && listaEnfermedadSeleccionada.length >= 1 ? true : !true} />
                  </div>
                  <div className="col-sm-8 order-sm-first">
                    {!wv && <ButtonBase icons={icnVolverInicio} callClick={this.cancelarStep} css="botonCancelar" etiqueta={i18n.t('ui.volverInicio')} enabled={motivosRechazoDisponibles} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-10 offset-sm-1 mtop10">
            <p>{i18n.t('ui.notaPie')}</p>
          </div>
        </div>
        <Loader visible={showLoader} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stepActual: state.step.stepActual,
    stepEstado: state.step.stepEstado,
    datosPersona: state.datosPersona.datosBasicosPersona,
    trackId: state.sessionUsuario.trackId,
    showLoader: state.loader.showLoader,
    modalErrorGenerico: state.modalError.showErrorGenerico,
    token: state.sessionUsuario.token,
    idFlujoSocio: state.obtenerCampanaUsuario.idFlujo,
    indicadorCurseSocio: state.indicadorCurse,
    simulacionEstado: state.simulacion.estado,
    simulacion: state.simulacion.detalleSimulacion,
    simulacionCodeError: state.simulacion.codeError,
    listaFormatoLabel: state.listaDeEnfermedades.listaFormatoLabel,
    enEjecucionAPIEnfermedadesPreExistentes: state.listaDeEnfermedades.enEjecucionAPIEnfermedadesPreExistentes,
    listaEnfermedadSeleccionada: state.listaDeEnfermedades.enfermedades,
    solicitar: state.solicitar.solicitar,
    motivosRechazoDisponibles: state.rechazo.motivosDisponible.length === 0 ? false : !false,
    listaSeguros: state.seguros.lista,
    listaSegurosSelecion: state.seguros.seleccion,
    wv: state.webViuw.estado
  }
}

const mapDispatchToProps = dispatch => {
  return {
    validaStep: (actual, estado) => dispatch(validarStepAction(actual, estado)),
    mostrarLoader: (value) => dispatch(loaderAction(value)),
    obtenerIndicadorCurse: (token, curse) => dispatch(indicadorCurse(token, curse)),
    obtenerDatosBasicosPersona: (value) => dispatch(obtenerDatosPersonaAction(value)),
    simular: (solicitud, renta, cuotas, listaSeguros, trackId) => dispatch(simularAction(solicitud, renta, cuotas, listaSeguros, trackId)),
    obtenerListaDeEnfermedadesPreExistentes: (value) => dispatch(obtenerListaDeEnfermedades(value)),
    ingresarEnfermedad: (tieneEnfermedad) => dispatch(ingresarEnfermedadPreexistenteAction(tieneEnfermedad)),
    enfermedadSeleccionada: (value) => dispatch(enfermedadSeleccionadaPorElSocio(value)),
    solicitarCredito: (enfermedades, trackId) => dispatch(solicitarCreditoAction(enfermedades, trackId)),
    mostrarCredito: () => dispatch(mostrarCreditoAction()),
    rechazar: () => dispatch(ModalRechazoAction(true)),
    seguros: () => dispatch(segurosAction())
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Simulador));
